const ORG_SEGMENT = /^\/o\/[^/]+(?=\/|$)/;
const COMMUNITY_ID_SEGMENT = /^(\/community)\/[^/?#]+/;
/**
 * A Discover link as it should be saved: copied from the address bar it names the admin's own
 * organization (/o/:orgId) and community (/community/:communityId); both ids are dropped so the app
 * opens the customer's own organization and most recent community instead. Other links and anything
 * that isn't a full http(s) URL are returned as they came.
 */
const normalizeDiscoverLink = (href) => {
    const value = href.trim();
    let url;
    try {
        url = new URL(value);
    }
    catch (_a) {
        return value;
    }
    if (url.protocol !== "https:" && url.protocol !== "http:")
        return value;
    const path = url.pathname.replace(ORG_SEGMENT, "") || "/";
    const generic = path.replace(COMMUNITY_ID_SEGMENT, "$1");
    if (generic === url.pathname)
        return value;
    return `${url.origin}${generic}${url.search}${url.hash}`;
};
/**
 * Whether a link leaves the app: a full http(s) URL on another origin, which the product opens in a
 * new tab. A path, or a URL on the app's own origin, stays in the app; anything else isn't followed.
 */
const opensAnotherSite = (href, appOrigin = window.location.origin) => {
    let url;
    try {
        url = new URL(href.trim(), appOrigin);
    }
    catch (_a) {
        return false;
    }
    return (url.protocol === "https:" || url.protocol === "http:") && url.origin !== appOrigin;
};

export { normalizeDiscoverLink, opensAnotherSite };
